import cart from './cart';
import product from './product';
import search from './search';

export default {
  catalog: {
    pages: {
      ...cart,
      ...product,
      ...search,
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/es-cl/buyer/catalog/index.js